<template>
  <span class="user-tag"
    ><UserAvatar :user-avatar="avatar" /><span>{{ userName }}</span></span
  >
</template>
<script>
import UserAvatar from '@/components/business/avatar/UserAvatar.vue'
export default {
  name: 'UserTag',
  props: {
    userName: {
      // 用户名
      type: String,
      required: true,
    },
    userId: {
      type: [String, Number],
      default: null
    },
    avatar: {
      type: String,
      default: null
    }
  },
  components: {
    UserAvatar,
  },
}
</script>
<style lang="less" scoped>
@import url(~@/styles/font.less);
.user-tag {
  .medium-font(16);
  display: inline-block;
  line-height: 1em;

  & > img {
    width: 1em;
    height: 1em;
    margin-right: 0.5em;
    border-radius: 2px;
    vertical-align: middle;
    pointer-events: none;
  }

  & > span {
    display: inline-block;
    vertical-align: middle;
    color: #6a6d73;
  }
}
</style>
